<template>
  <div class="bg-zt-normal py-4 rounded-zt h-full" :class="{ 'pb-2': selectedTab === 'TabCommentaries' }">

    <div v-if="commentaryData.status === 'NS'"
         @click="scrollToCommentary();"
         class="bg-zt-light/35 h-[50px] flex justify-center items-center border border-zt-light
              rounded-zt text-sm mx-2 font-medium mb-4 xl:text-base">
      <span>START GALI:</span>
      <span class="text-zt-more ml-1">{{ commentaryData.startDateTime.toFormat('dd.LL.yyyy') }}</span>
      <svg class="inline ml-2 mt-px" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.10574 2.96853C6.10574 2.86836 6.06272 2.77228 5.98614 2.70145C5.90956 2.63061 5.8057 2.59082 5.6974 2.59082C5.5891 2.59082 5.48524 2.63061 5.40866 2.70145C5.33208 2.77228 5.28906 2.86836 5.28906 2.96853V7.12336C5.28909 7.18994 5.30813 7.25533 5.34427 7.3129C5.38042 7.37048 5.43237 7.41819 5.49487 7.45122L8.35324 8.96206C8.44704 9.00896 8.55696 9.02005 8.65948 8.99298C8.76201 8.9659 8.84903 8.9028 8.90193 8.81717C8.95483 8.73154 8.96942 8.63016 8.94258 8.53471C8.91575 8.43926 8.84961 8.3573 8.75832 8.30635L6.10574 6.90429V2.96853Z" fill="#667995"/>
        <path d="M6.20312 11.7578C7.66182 11.7578 9.06076 11.1784 10.0922 10.1469C11.1237 9.11545 11.7031 7.7165 11.7031 6.25781C11.7031 4.79912 11.1237 3.40018 10.0922 2.36873C9.06076 1.33728 7.66182 0.757813 6.20312 0.757812C4.74443 0.757813 3.34549 1.33728 2.31404 2.36873C1.28259 3.40018 0.703125 4.79912 0.703125 6.25781C0.703125 7.7165 1.28259 9.11545 2.31404 10.1469C3.34549 11.1784 4.74443 11.7578 6.20312 11.7578ZM11.0156 6.25781C11.0156 7.53417 10.5086 8.75824 9.60608 9.66076C8.70356 10.5633 7.47948 11.0703 6.20312 11.0703C4.92677 11.0703 3.70269 10.5633 2.80017 9.66076C1.89765 8.75824 1.39062 7.53417 1.39062 6.25781C1.39062 4.98146 1.89765 3.75738 2.80017 2.85486C3.70269 1.95234 4.92677 1.44531 6.20312 1.44531C7.47948 1.44531 8.70356 1.95234 9.60608 2.85486C10.5086 3.75738 11.0156 4.98146 11.0156 6.25781Z" fill="#667995"/>
      </svg>
      <span class="text-[#667995] ml-1">{{ commentaryData.startDateTime.toFormat('HH:mm') }}</span>
    </div>
    <div v-else-if="commentaryData.status === 'IP'"
         @click="scrollToCommentary();"
         class="bg-zt-light/30 h-[50px] flex justify-center items-center border border-zt-light
              rounded-zt text-sm font-medium mx-2 mb-4 xl:text-base">
      <span>RELACJA TEKSTOWA</span>
      <span class="text-zt-red ml-1">TRWA</span>
      <svg class="inline ml-2 mt-px animate-[pulse_1s_ease-in-out_infinite] mb-1" width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.67709 0.663515C4.96999 0.956415 4.96999 1.43129 4.67709 1.72418C1.35764 5.04363 1.35764 10.4256 4.67709 13.745C4.96999 14.0379 4.96999 14.5128 4.67709 14.8057C4.3842 15.0986 3.90933 15.0986 3.61643 14.8057C-0.28881 10.9004 -0.28881 4.56877 3.61643 0.663515C3.90933 0.370625 4.3842 0.370625 4.67709 0.663515ZM17.7586 0.663515C21.6638 4.56877 21.6638 10.9004 17.7586 14.8057C17.4657 15.0986 16.9908 15.0986 16.6979 14.8057C16.405 14.5128 16.405 14.0379 16.6979 13.745C20.0174 10.4256 20.0174 5.04363 16.6979 1.72418C16.405 1.43129 16.405 0.956415 16.6979 0.663515C16.9908 0.370625 17.4657 0.370625 17.7586 0.663515ZM7.50552 3.49195C7.79841 3.78484 7.79841 4.25972 7.50552 4.55261C5.74816 6.30997 5.74816 9.15916 7.50552 10.9166C7.79841 11.2095 7.79841 11.6844 7.50552 11.9773C7.21263 12.2702 6.73775 12.2702 6.44486 11.9773C4.10171 9.63406 4.10171 5.83507 6.44486 3.49195C6.73775 3.19906 7.21263 3.19906 7.50552 3.49195ZM14.9301 3.49195C17.2733 5.83507 17.2733 9.63406 14.9301 11.9773C14.6372 12.2702 14.1624 12.2702 13.8695 11.9773C13.5766 11.6844 13.5766 11.2095 13.8695 10.9166C15.6268 9.15916 15.6268 6.30997 13.8695 4.55261C13.5766 4.25972 13.5766 3.78484 13.8695 3.49195C14.1624 3.19906 14.6372 3.19906 14.9301 3.49195ZM10.6875 6.23456C11.5159 6.23456 12.1875 6.90616 12.1875 7.73456C12.1875 8.56296 11.5159 9.23456 10.6875 9.23456C9.8591 9.23456 9.1875 8.56296 9.1875 7.73456C9.1875 6.90616 9.8591 6.23456 10.6875 6.23456Z" fill="#FF4A5D"/>
      </svg>
    </div>
    <div v-else
         @click="scrollToCommentary();"
         class="bg-zt-light/30 h-[50px] flex justify-center items-center border border-zt-light
              rounded-zt text-sm font-medium mx-2 mb-4 xl:text-base">
      <span v-if="!loading" class="text-[#667995]">RELACJA TEKSTOWA ZAKOŃCZONA</span>
      <div v-else class="spinner" role="status">
        <span class="invisible">Wczytywanie...</span>
      </div>
    </div>

    <div id="absolute-tabs-swiper"
         class="sticky top-0 z-10 flex justify-center w-full transition-shadow bg-[#263042] border-t
                border-zt-light/35 left-0 text-white xl:mb-2.5 xl:pt-2.5">
      <div class="overflow-x-auto os mx-2 py-2 xl:pb-0 xl:pt-2">
        <div class="flex flex-row w-fit gap-x-2 xl:justify-center xl:pb-0"
             :class="{'pt-1' : additionalCommentary}">
          <div class="swiper-slide w-fit xl:w-[120px] h-7"
              :class="[ selectedTab === 'TabCommentaries' ? 'filtering-button-active' : 'filtering-button-inactive',
                        commentaryData.status === 'IP' && !additionalCommentary ? '!px-1' : '']"
              @click="changeTab('TabCommentaries');">
            <span v-if="commentaryData.status === 'IP' && !additionalCommentary" class="pt-px">
              <svg class="inline mr-0.5 fill-white" width="21" height="16" viewBox="0 0 21 16" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.67709 0.663515C4.96999 0.956415 4.96999 1.43129 4.67709 1.72418C1.35764 5.04363 1.35764 10.4256 4.67709 13.745C4.96999 14.0379 4.96999 14.5128 4.67709 14.8057C4.3842 15.0986 3.90933 15.0986 3.61643 14.8057C-0.28881 10.9004 -0.28881 4.56877 3.61643 0.663515C3.90933 0.370625 4.3842 0.370625 4.67709 0.663515ZM17.7586 0.663515C21.6638 4.56877 21.6638 10.9004 17.7586 14.8057C17.4657 15.0986 16.9908 15.0986 16.6979 14.8057C16.405 14.5128 16.405 14.0379 16.6979 13.745C20.0174 10.4256 20.0174 5.04363 16.6979 1.72418C16.405 1.43129 16.405 0.956415 16.6979 0.663515C16.9908 0.370625 17.4657 0.370625 17.7586 0.663515ZM7.50552 3.49195C7.79841 3.78484 7.79841 4.25972 7.50552 4.55261C5.74816 6.30997 5.74816 9.15916 7.50552 10.9166C7.79841 11.2095 7.79841 11.6844 7.50552 11.9773C7.21263 12.2702 6.73775 12.2702 6.44486 11.9773C4.10171 9.63406 4.10171 5.83507 6.44486 3.49195C6.73775 3.19906 7.21263 3.19906 7.50552 3.49195ZM14.9301 3.49195C17.2733 5.83507 17.2733 9.63406 14.9301 11.9773C14.6372 12.2702 14.1624 12.2702 13.8695 11.9773C13.5766 11.6844 13.5766 11.2095 13.8695 10.9166C15.6268 9.15916 15.6268 6.30997 13.8695 4.55261C13.5766 4.25972 13.5766 3.78484 13.8695 3.49195C14.1624 3.19906 14.6372 3.19906 14.9301 3.49195ZM10.6875 6.23456C11.5159 6.23456 12.1875 6.90616 12.1875 7.73456C12.1875 8.56296 11.5159 9.23456 10.6875 9.23456C9.8591 9.23456 9.1875 8.56296 9.1875 7.73456C9.1875 6.90616 9.8591 6.23456 10.6875 6.23456Z"/>
              </svg>
              NA ŻYWO
            </span>
            <span v-else>RELACJA</span>
          </div>
          <div v-if="videosPresent" class="swiper-slide w-fit xl:w-[120px] h-7"
               :class="[ selectedTab === 'TabVideo' ? 'filtering-button-active' : 'filtering-button-inactive' ]"
               @click="changeTab('TabVideo', 0, $event.target);">
            VIDEO
          </div>
          <div class="swiper-slide w-fit xl:w-[120px] h-7"
              :class="[ selectedTab === 'TabFights' ? 'filtering-button-active' : 'filtering-button-inactive' ]"
              @click="changeTab('TabFights', 0, $event.target);">
            KARTA WALK
          </div>
          <div v-if="galaName !== 'KSW 83: Colosseum 2'"
          class="swiper-slide w-fit xl:w-[120px] h-7"
              :class="[ selectedTab === 'TabCompetitors' ? 'filtering-button-active' : 'filtering-button-inactive' ]"
              @click="changeTab('TabCompetitors', 1, $event.target);">
            ZAWODNICY
          </div>
          <div class="swiper-slide w-fit xl:w-[120px] h-7"
              :class="[ selectedTab === 'TabGalas' ? 'filtering-button-active' : 'filtering-button-inactive' ]"
              @click="changeTab('TabGalas', 2, $event.target);">
            INNE GALE
          </div>
          <div class="pr-2 xl:pr-0" :class="bookmakerContent.length > 0 ? '' : 'pointer-events-none opacity-30'">
            <div class="swiper-slide w-fit xl:w-[120px] h-7"
              :class="[ selectedTab === 'TabBookmaker' ? 'filtering-button-active' : 'filtering-button-inactive' ]"
              @click="changeTab('TabBookmaker', 4, $event.target);">
            BUKMACHER
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="border-zt-light/35 mb-4 mx-2 xl:mx-0">

    <keep-alive>
      <component :is="selectedTab" :galaId="galaId" :galaName="galaName" :commentaryData="commentaryData"
                 :dataLoading="commentaryLoading" :additional="Number(additionalCommentary)"
                 :bookmakerContent="bookmakerContent"/>
    </keep-alive>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import { defineAsyncComponent } from 'vue';
import TabCommentaries from '../commentary_tabs/Commentaries.vue';
import TabBookmaker from '../commentary_tabs/Bookmaker.vue';
import TabVideo from '../commentary_tabs/Video.vue'
import { countClicks } from '../../../assets/js/utils';

export default {
  name: 'Commentary',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    TabCommentaries,
		TabVideo,
    TabCompetitors: defineAsyncComponent(() => import('../commentary_tabs/Competitors.vue')),
    TabGalas: defineAsyncComponent(() => import('../commentary_tabs/Galas.vue')),
    TabFights: defineAsyncComponent(() => import('../blocks/FightCard.vue')),
    TabBookmaker,
  },
  data() {
    return {
      galaId: Number(this.$attrs.galaid),
      galaName: '',
      selectedTab: 'TabCommentaries',
      commentaryData: {
        id: 0,
        status: '',
        startDateTime: null,
        endDateTime: null,
        commentaryPlanned: false,
        commentaryMsgs: [],
        newMessagesIds: [],
        soundEnabled: false,
        link: '',
        galaIsEnded: null,
      },
      follows: 0,
      additionalCommentary: this.$attrs.additional,
			loading: true,
			videosPresent: false,
      bookmakerContent: '',
      navItems: [
        {
          name: 'NA ŻYWO',
          query_name: 'relacja',
          tab: 'TabCommentaries',
        },
        {
          name: 'VIDEO',
          query_name: 'video',
          tab: 'TabVideo',
        },
        {
          name: 'KARTA WALK',
          query_name: 'karta-walk',
          tab: 'TabFights',
        },
        {
          name: 'ZAWODNICY',
          query_name: 'zawodnicy',
          tab: 'TabCompetitors',
        },
        {
          name: 'INNE GALE',
          query_name: 'gale',
          tab: 'TabGalas',
        },
        {
          name: 'BUKMACHER',
          query_name: 'bukmacher',
          tab: 'TabBookmaker',
        },
      ],
      commentaryLoading: true,
      isModalOpen: false,
      scrollbarInstance: null
    }
  },
  mounted() {
    this.getCommentary();

    let refreshCounter = sessionStorage.getItem('refreshCounter');
    if (String(window.performance.getEntriesByType("navigation")[0].type) === "reload" && !this.additionalCommentary
        && this.commentaryData.status === 'IP') {
      if (refreshCounter === '3') {
        alert("Komentarze odświeżają się automatycznie bez opóźnienia.\nNie musisz odświeżać strony.");
        sessionStorage.setItem('refreshCounter', '1');
      } else {
        sessionStorage.setItem('refreshCounter', +refreshCounter + 1 +'');
      }
    }

    this.scrollbarInstance = this.initializeScrollbar('.os',
        {scrollbars: {
            dragScroll: false,
            autoHide: 'scroll',
            theme: 'os-theme-custom',
            autoHideDelay: 1300,
          }});
    if (!this.additionalCommentary && window.webSocketsEnabled && !window.PHP.bot) {
      this.addWSListeners();
      setInterval(() => {
        this.commentaryData.currentlyFollows = this.follows;
      }, 15000);
    }

		if (!window.size.mobile) {
			return;
		}

    this.stickyFollowHeader('absolute-tabs-swiper', this.WP.user.adminBar,
      this.additionalCommentary ? 48 : 0);
  },
	watch: {
		commentaryData : {
			handler(newVal) {
				if (newVal.commentaryMsgs.length > 0 && this.additionalCommentary !== '1') {
					this.videosPresent = newVal.commentaryMsgs.findIndex(msg => msg.is_video === '1') !== -1;
				}
			}, deep: true
		},
    commentaryLoading : {
      handler(newVal) {
        if (newVal === false) {
            let tab = 'TabCommentaries';
            if ((this.commentaryData.status === 'EN' || this.commentaryData.status === '') && this.commentaryData.commentaryMsgs.length === 0) {
              tab = 'TabFights'
            }
            let hash = window.location.hash.substring(1);
            const availableTabs = this.navItems.map(item => item.query_name);
            if (availableTabs.includes(hash)) {
              tab = this.getNavItemType(hash);
            }
            this.selectedTab = tab;
            if (tab === 'TabCommentaries') {
              this.selectedTab = tab;
              if (hash === 'relacja') {
                let urlWithoutHash = window.location.href.substring(0, window.location.href.indexOf('#'));
                window.history.replaceState(null, '', urlWithoutHash);
              }
            }
        }
      }, deep: true
    }
	},
  methods: {
    scrollToElementInCenter(element) {
      if (this.scrollbarInstance && element) {
        const container = this.scrollbarInstance.elements().viewport;
        const containerWidth = container.clientWidth;

        const elementRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        const scrollLeftPosition =
            container.scrollLeft + elementRect.left - containerRect.left - containerWidth / 2 + element.offsetWidth / 2;

        container.scrollTo({
          left: scrollLeftPosition,
          behavior: "smooth", // Dodaje animację przesuwania
        });
      }
    },
    setup() {
      this.getBookmakerContent();
      if (this.commentaryData.id !== 0) {
        this.getCommentaryMessages();
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            this.commentaryData.newMessagesIds = [];
          }
        });
      } else {
        this.commentaryLoading = false;
      }
    },
    getCommentaryMessages() {
      axios
          .post(this.WP.ajaxUrl, {
            endpoint: 'api_get_commentary_msgs_by_commentary_id',
            commentary_id: this.commentaryData.id,
          })
          .then(response => {
            this.commentaryData.commentaryMsgs = response.data.data.map(msg => {
              msg.key_moment = msg.key_moment === '1';
              msg.fight_start = msg.fight_start === '1';
              msg.id = Number(msg.id);
              msg.is_poll = msg.is_poll === '1';
              msg.commentary_id = Number(msg.commentary_id);
              return msg;
            });
            this.commentaryLoading = false;
          });
    },
    getNavItemType(tabQueryName) {
      for (let navItem of this.navItems) {
        if (navItem.query_name === tabQueryName) {
          return navItem.tab;
        }
      }
      return '';
    },
    getNavItemQueryName(tabType) {
      for (let navItem of this.navItems) {
        if (navItem.tab === tabType) {
          return navItem.query_name;
        }
      }
      return '';
    },
		scrollToCommentary() {
			document.querySelector('[data-component="relacja"]').scrollIntoView({block: 'start'});
		},
    changeTab(tabName, n,  target) {
      if (this.selectedTab === 'TabCommentaries' && tabName !== 'TabCommentaries') {
        window.history.replaceState(null, '',
            `${window.location.href}#${this.getNavItemQueryName(tabName).toLowerCase()}`);
      } else if (this.activeTab !== 'TabCommentaries' && tabName === 'TabCommentaries') {
        window.history.replaceState(null, '',
            `${window.location.href.substring(0, window.location.href.indexOf('#'))}`);
      } else {
        window.history.replaceState(null, '',
            `${window.location.href.substring(0, window.location.href.indexOf('#') + 1)}${this.getNavItemQueryName(tabName).toLowerCase()}`);
      }

      if (this.selectedTab !== tabName) {
        this.scrollToElementInCenter(target);
        this.selectedTab = tabName;
      }
      
      if (this.additionalCommentary) {
        countClicks('Relacja kopia przełączniki');
      }
    },
    getCommentary() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_commentary',
          gala_id: this.galaId,
          additional: this.additionalCommentary,
        })
        .then(response => {
          if (response.data.success) {
            let commentary = response.data.data;
            this.commentaryData.id = Number(commentary.id);
            this.commentaryData.startDateTime = this.DateTime.fromSQL(commentary.start_date);
            this.commentaryData.endDateTime = this.DateTime.fromSQL(commentary.end_date);
            this.commentaryData.commentaryPlanned = commentary.is_relation_planned;
            this.commentaryData.link = commentary.post_link;
            this.galaName = commentary.gala_name;
            this.commentaryData.status = commentary.status;
            this.commentaryData.galaIsEnded = commentary.is_ended;
            this.loading = false;
            if (!this.additionalCommentary) {
              socket?.emit('commentary-follows', {
                commentary_id: this.commentaryData.id,
              });
            }
          }
          this.setup();
        });
    },
    addWSListeners() {
      socket?.on('new-commentary', data => {
        if (Number(data.commentary_id) === this.commentaryData.id) {
          setTimeout(() => {
            let idx = this.commentaryData.newMessagesIds.indexOf(Number(data.id));
            this.commentaryData.newMessagesIds.splice(idx, 1);
          }, 6000);
          this.commentaryData.commentaryMsgs.unshift(data);
          this.commentaryData.newMessagesIds.push(Number(data.id));
          if (this.commentaryData.soundEnabled) {
            const audio = new Audio('/wp-content/themes/zawodtyper/assets/audio/relacja_nowy_wpis.mp3');
            audio.volume = 1;
            audio.play().then().catch();
          }
        }
      });
      socket?.on('edit-commentary', data => {
        if (Number(data.commentary_id) === this.commentaryData.id) {
          let index = this.commentaryData.commentaryMsgs.findIndex(commentary => Number(commentary.id) === Number(data.id));
          this.commentaryData.commentaryMsgs[index] = data;
        }
      });
      socket?.on('remove-commentary', data => {
        if (Number(data.commentary_id) === this.commentaryData.id) {
          let index = this.commentaryData.commentaryMsgs.findIndex(commentary => Number(commentary.id) === Number(data.id));
          this.commentaryData.commentaryMsgs.splice(index, 1);
        }
      });
      socket?.on('datetime-commentary', data => {
        if (Number(data.commentary_id) === this.commentaryData.id) {
          this.commentaryData.startDateTime = this.DateTime.fromFormat(data.startDateTime, 'yyyy-MM-dd HH:mm:ss');
          this.commentaryData.endDateTime = this.DateTime.fromFormat(data.endDateTime, 'yyyy-MM-dd HH:mm:ss');
        }
      });
      socket?.on('status-commentary', data => {
        if (Number(data.commentary_id) === this.commentaryData.id) {
          this.commentaryData.status = data.status;
          if (data.isDateChanged === true) {
            this.commentaryData.endDateTime = this.DateTime.fromFormat(data.endDateTime, 'yyyy-MM-dd HH:mm:ss');
          }
        }
      });
      socket?.on('commentary-follows', data => {
        if (Number(data.commentary_id) === this.commentaryData.id) {
          if (this.follows === 0) {
            this.commentaryData.currentlyFollows = data.follows;
          }
          this.follows = data.follows;
        }
      });
    },
    getBookmakerContent() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_get_commentary_bookmaker_tab_content',
          gala_id: this.galaId,
          raw: false,
        })
        .then(response => {
          if (response.data.success) {
            this.bookmakerContent = response.data.data;
          }
        });
    },
    showModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  }
};
</script>
<style>
.filtering-button-main,
.filtering-button-inactive,
.filtering-button-number,
.filtering-button-active {
  @apply uppercase text-xs text-zt-more cursor-pointer font-medium py-1 px-4 h-7 border border-zt-light
  rounded flex items-center justify-center !text-center flex-nowrap !leading-normal;
}

.filtering-button-main {
  @apply whitespace-nowrap text-white;
}

.filtering-button-main:hover,.filtering-button-number:hover, .filtering-button-inactive:hover  {
  @apply bg-zt-light/35 border-zt-light;
}

.filtering-button-number {
  @apply border-transparent;
}

.filtering-button-active {
  @apply text-white !bg-zt-light border-zt-light;
}

.os {
  @apply pb-2 !important;
}
</style>